import React, { useMemo, useState } from 'react';
import { Justify, SearchBox, Table, ConfigProvider } from 'tea-component';
const { pageable, scrollable } = Table.addons;

import { getLocale, useIntl, useLocation } from 'umi';
import CardCommon from '@/pages/opinion/components/CardCommon';
import { getTeaLocale } from '@/pages/home/utils/lang';
import '../../styles/index.less';

const Data = ({
  records,
  columns,
  className,
  justifyClassName,
  searchClassName,
  placeholder,
  recordKey,
  loading = false,
  filterKey,
}: {
  records: any[];
  columns: (pageIndex: number, pageSize: number, search?: string) => any[];
  className: string;
  justifyClassName: string;
  searchClassName: string;
  placeholder: string;
  recordKey: string;
  loading?: boolean;
  filterKey?: Array<string>;
}) => {
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(50);

  const { formatMessage } = useIntl();
  const locale = getLocale();

  const localtion = useLocation();
  

  const [search, setSearch] = useState(localtion?.query?.keyword || "");

  const handleOnSearch = (value: string | undefined) => {
    setSearch(value || '');
  };

  const handleOnClear = () => {
    setSearch('');
  };

  const renderList = useMemo(() => {
    setPageIndex(1);
    const trimSearch = search.trim();
    if (trimSearch === '') return records;
    return records.filter((item) => {
      const keys = filterKey || Object.keys(item);
      return keys.some((key: any) => {
        const value = String(item[key]) || '';
        const lowValue = value?.toLocaleLowerCase() || '';
        const lowSearch = search?.toLocaleLowerCase() || '';
        return lowValue?.includes?.(lowSearch);
      });
    });
  }, [search, records]);

  return (
    <>
      <Justify
        className={justifyClassName}
        right={
          <SearchBox
            className={searchClassName}
            onSearch={handleOnSearch}
            onClear={handleOnClear}
            defaultValue={search}
            placeholder={formatMessage({ id: placeholder })}
          />
        }
      />

      <CardCommon
        loading={loading}
        loadingHeight={260}
        empty={!(renderList?.length > 0)}
        emptyHeight={400}
        emptyTitleText="No entities found by current keyword"
        emptyDescText="Please try another keyword or search on other tables for the information you are looking for."
      >
        <ConfigProvider locale={getTeaLocale(locale)}>
          <div style={{ position: 'relative' }}>
            <div className="user-guide-data-source-mask"></div>
            <Table
              rowClassName={() => 'sources-table-row'}
              className={className}
              verticalTop
              records={renderList}
              recordKey={recordKey}
              columns={columns(pageIndex, pageSize, search)}
              addons={[
                pageable({
                  pageIndex,
                  pageSize,
                  onPagingChange: (params) => {
                    setPageIndex(params.pageIndex || 1);
                    setPageSize(params.pageSize || 10);
                  },
                }),
                scrollable({}),
              ]}
            />
          </div>
        </ConfigProvider>
      </CardCommon>
    </>
  );
};

export default Data;
